import { render, staticRenderFns } from "./selectReceptorUsoCFDI.vue?vue&type=template&id=7da970d6"
import script from "./selectReceptorUsoCFDI.vue?vue&type=script&lang=js"
export * from "./selectReceptorUsoCFDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports